import { useEffect, useMemo, useState } from 'react';
import { insurersService } from '../services/insurersService';
import { InsurerPublic } from '../types/api/responses';
import { getPartnerCompanyTitle, normalizeCompanyCode } from '../helpers/companyAliases';

export function useInsurers() {
  const [insurers, setInsurers] = useState<InsurerPublic[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    insurersService()
      .then(([err, res]) => {
        if (err || !res || res.error) return;
        setInsurers(res.data?.items ?? []);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const titleByCode = useMemo(() => {
    const map: Record<string, string> = {};
    insurers.forEach((i) => {
      map[normalizeCompanyCode(i.code)] = i.title;
    });
    return map;
  }, [insurers]);

  const getCompanyTitle = useMemo(
    () => (code: string) => titleByCode[normalizeCompanyCode(code)] || getPartnerCompanyTitle(code) || code,
    [titleByCode],
  );

  return { insurers, isLoading, titleByCode, getCompanyTitle };
}
